const ContributionCounter = () => {
  const COUNTER = 554;

  return (
    <div>
      <p>
        <b>{COUNTER} contributions have been collected so far.</b>
      </p>
    </div>
  );
};

export default ContributionCounter;
